const Sidenav = ({ isOpen, onClose, children, theme, header }) => {
  return (
    <div
      className={`sidenav sidenav--${header} sidenav--${theme}  ${
        isOpen ? `sidenav--open  sidenav--open--${theme}` : ""
      }`}
    >
      <button className="closebtn" onClick={onClose}>
        &times;
      </button>
      {children}
    </div>
  );
};

export default Sidenav;
